import React from 'react';
import { useDispatch } from 'react-redux';
import { AGENT_LIST } from '@common/constants';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatSelect from '@components/common/satUI/SatSelect';
import SatInput from '@components/common/satUI/SatInput';
import { updateAuthCustomerInfo } from '@store/actions/eaAction';
import SecurityInput from '@components/common/biz/SecurityInput';

// props에 따라서 reducer랑 값 달라지게 분기처리하기
const EaVerifyId = props => {
  const dispatch = useDispatch();

  const { authCustomerInfo, driveNumKey } = props;
  const { regionCodes } = $hooks.useConstant();

  const ID_CARD_LIST = [
    { key: 'D', label: '운전면허증', value: 'D' },
    { key: 'R', label: '주민등록증', value: 'R' },
    { key: 'F', label: '외국인등록증', value: 'F' },
  ];

  const handleMobileCheckClick = value => {
    dispatch(
      updateAuthCustomerInfo({
        mobileCorp: value[0].value,
      }),
    );
  };

  const habndleIdCardClick = value => {
    // setIdTabSelected(value);
    dispatch(
      updateAuthCustomerInfo({
        idCardType: value,
      }),
    );
  };

  const handleVerifyType = type => {
    dispatch(
      updateAuthCustomerInfo({
        verifyType: type,
      }),
    );
  };

  const handleDriveRegionInputEvent = regionCode => {
    dispatch(
      updateAuthCustomerInfo({
        regionCode: regionCode,
        reqType: 'I',
      }),
    );
  };

  const handleDriveIdCardNoInputEvent = driverIdValue => {
    {
      /* @NOTE: 보안 키패드 사용 여부 값에 따른 처리 */
    }
    if ($utils.checkSecureKeypad()) {
      dispatch(
        updateAuthCustomerInfo({
          driveNumberSecurityObj: { ...driverIdValue },
          reqType: 'I',
        }),
      );
    } else {
      dispatch(
        updateAuthCustomerInfo({
          idCardNo: driverIdValue,
          reqType: 'I',
        }),
      );
    }
  };

  const handleRegidentCardInputEvent = value => {
    dispatch(
      updateAuthCustomerInfo({
        issueDateR: value,
        reqType: 'I',
      }),
    );
  };

  const handleForeignCardInputEvent = (value, type) => {
    dispatch(
      updateAuthCustomerInfo(
        type == '1'
          ? {
              issueDateF: value,
              reqType: 'F',
            }
          : {
              collateralNo: value,
              reqType: 'F',
            },
      ),
    );
  };

  return (
    <>
      <div className="toggle-wrap">
        <div
          className={`line-box ${
            authCustomerInfo.insuredPrspInfo.verifyType === 'SMS' && 'on'
          }`}
        >
          <div className="check-wrap type-left">
            <input
              type="radio"
              name="select-list"
              id="telecom1"
              checked={authCustomerInfo.insuredPrspInfo.verifyType === 'SMS'}
              onChange={() => handleVerifyType('SMS')}
            />
            <label htmlFor="telecom1">휴대전화로 인증 (통신사 선택)</label>
          </div>
          <div className="btn-group col3">
            <SatCheckBox
              type="button"
              value={[authCustomerInfo.insuredPrspInfo.mobileCorp]}
              options={AGENT_LIST}
              checkOne
              onChange={value => handleMobileCheckClick(value)}
            />
          </div>
        </div>
        <div
          className={`line-box ${
            authCustomerInfo.insuredPrspInfo.verifyType === 'IDCARD' && 'on'
          }`}
        >
          <div className="check-wrap type-left">
            <input
              type="radio"
              name="select-list"
              id="telecom2"
              checked={authCustomerInfo.insuredPrspInfo.verifyType === 'IDCARD'}
              onChange={() => handleVerifyType('IDCARD')}
            />
            <label htmlFor="telecom2">신분증 인증 (신분증 선택)</label>
          </div>
          <div className="tab-wrap">
            <ul className="tab-nav">
              {ID_CARD_LIST.map((data, index) => {
                return (
                  <React.Fragment key={`idCardList_${index}`}>
                    <li
                      data-tab={`con-tab${index + 1}`}
                      className={
                        authCustomerInfo.insuredPrspInfo.idCardType ===
                        ID_CARD_LIST[index].value
                          ? 'active'
                          : ''
                      }
                    >
                      <a
                        className="tab"
                        onClick={() =>
                          habndleIdCardClick(ID_CARD_LIST[index].value)
                        }
                      >
                        {ID_CARD_LIST[index].label}
                      </a>
                    </li>
                  </React.Fragment>
                );
              })}
            </ul>
            <div
              className={`tab-con ${
                authCustomerInfo.insuredPrspInfo.idCardType ===
                ID_CARD_LIST[0].value
                  ? 'active'
                  : ''
              }`}
              id="con-tab1"
            >
              <div className="box">
                <SatSelect
                  title={'지역번호선택'}
                  label={'지역번호선택'}
                  value={authCustomerInfo.insuredPrspInfo.regionCode}
                  border={true}
                  options={regionCodes}
                  customStyleClass={'license01'}
                  onChange={option => handleDriveRegionInputEvent(option.value)}
                />

                {/* @NOTE: 보안 키패드 사용 여부 값에 따른 처리 */}
                {$utils.checkSecureKeypad() ? (
                  <SecurityInput
                    value={
                      authCustomerInfo.insuredPrspInfo.driveNumberSecurityObj
                        ?.value
                    }
                    encryptionKey={driveNumKey}
                    label={'면허번호'}
                    maxLength={10}
                    customStyleClass={'license02'}
                    onChange={value => handleDriveIdCardNoInputEvent(value)}
                  />
                ) : (
                  <SatInput
                    border
                    isPrivacy
                    isRandomPad
                    label="면허번호"
                    type="number"
                    customStyleClass={'license02'}
                    value={authCustomerInfo.insuredPrspInfo?.idCardNo}
                    maxLength="10"
                    onChange={value => handleDriveIdCardNoInputEvent(value)}
                  />
                )}
              </div>
              <p className="text-info2 ico-type">
                2014년 7월 14일 이전은 지역명과 숫자를 확인하고, 이후 면허는
                숫자를 확인해주세요.
              </p>
            </div>
            <div
              className={`tab-con ${
                authCustomerInfo.insuredPrspInfo.idCardType ===
                ID_CARD_LIST[1].value
                  ? 'active'
                  : ''
              }`}
              id="con-tab2"
            >
              <SatInput
                value={authCustomerInfo.insuredPrspInfo.issueDateR}
                label="발급일자"
                type="number"
                border
                useDate
                maxLength={8}
                onChange={value => handleRegidentCardInputEvent(value)}
              />
              <p className="text-info2 ico-type">
                기관 정보 제외, 발급 일자는 숫자로만 작성해주세요.
              </p>
            </div>
            <div
              className={`tab-con ${
                authCustomerInfo.insuredPrspInfo.idCardType ===
                ID_CARD_LIST[2].value
                  ? 'active'
                  : ''
              }`}
              id="con-tab3"
            >
              <SatInput
                value={authCustomerInfo.insuredPrspInfo.issueDateF}
                label="발급일자"
                type="number"
                border
                useDate
                maxLength={8}
                onChange={value => handleForeignCardInputEvent(value, '1')}
              />
              <p className="text-info2 ico-type">
                기관 정보 제외, 발급 일자는 숫자로만 작성해주세요.
              </p>
              <SatInput
                value={authCustomerInfo.insuredPrspInfo.collateralNo}
                label="일련번호(뒷면 11자리)"
                type="number"
                maxLength={11}
                border
                onChange={value => handleForeignCardInputEvent(value, '2')}
              />
              <p className="text-info2 ico-type">
                외국인등록증 뒷면 일련번호 11자리를 작성해주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EaVerifyId;
